import { render, staticRenderFns } from "./publicizeMaterialMaintenance.vue?vue&type=template&id=b565734c&"
import script from "./publicizeMaterialMaintenance.vue?vue&type=script&lang=js&"
export * from "./publicizeMaterialMaintenance.vue?vue&type=script&lang=js&"
import style0 from "./publicizeMaterialMaintenance.vue?vue&type=style&index=0&id=b565734c&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b565734c')) {
      api.createRecord('b565734c', component.options)
    } else {
      api.reload('b565734c', component.options)
    }
    module.hot.accept("./publicizeMaterialMaintenance.vue?vue&type=template&id=b565734c&", function () {
      api.rerender('b565734c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/publicizeMaterialManagement/publicizeMaterialMaintenance.vue"
export default component.exports